'use strict';

// Carousel for primary image
const $carouselSlider = $('.cc-pdp__carousel__slider');
const $carouselPrevArrow = $('.js-carouselPrev');
const $carouselNextArrow = $('.js-carouselNext');
const $mainImage = $('.js-carouselMainImage');
const $mainImageButton = $('.js-mainImageButton');
const $mainVideoButton = $('.js-mainVideoButton');
const $zoomImageModal = $('.cc-pdp__zoomImage');
const $zoomCarousel = $('.cc-pdp__zoomImage__slider');
const $zoomNavCarousel = $('.cc-pdp__zoomImage__navCarousel__slider');
const $functionalitySlider = $('.cc-pdp__machineFunctionality');
const $compatibleSlider = $('.cc-pdp__characteristics__compatible__slider');

let _pendingSlideIndex = null;
let _pendingClearTimeout = null;

function getCarouselArrowLabels() {
    const $labels = $('#carouselAccessibilityLabels');

    return {
        previous: $labels.attr('data-previous-slide-label') || '',
        next: $labels.attr('data-next-slide-label') || ''
    };
}

function destroyMainCarousel() {
    if ($carouselSlider.hasClass('slick-initialized')) {
        $carouselSlider.slick('unslick');
    }
}

/**
 * Initialize the main carousel
 */
function initMainCarousel() {
    destroyMainCarousel();
    const arrowLabels = getCarouselArrowLabels();
    $carouselPrevArrow.attr('aria-label', arrowLabels.previous);
    $carouselNextArrow.attr('aria-label', arrowLabels.next);

    $carouselSlider.slick({
        arrows: true,
        prevArrow: $carouselPrevArrow,
        nextArrow: $carouselNextArrow,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    vertical: false,
                    verticalSwiping: false,
                    dots: true,
                }
            }
        ]
    });

    updateMainCarouselArrows();
    attachMainCarouselEvents();

    if (window.isDesktop) {
        $carouselSlider.find('.cc-pdp__carousel__item').removeAttr('data-toggle').removeAttr('data-target');
    }
    else {
        $carouselSlider.find('.cc-pdp__carousel__item').attr('data-toggle', 'modal').attr('data-target', '#zoomImageModal');
    }
}

/**
 * Update arrow states based on carousel position
 */
function updateMainCarouselArrows() {
    if (!$carouselSlider.hasClass('slick-initialized')) return;

    const slick = $carouselSlider.slick('getSlick');
    const currentSlide = slick.currentSlide;
    const slideCount = slick.slideCount;
    const slidesToShow = slick.options.slidesToShow;

    if (currentSlide === 0) {
        $carouselPrevArrow.addClass('is-disabled');
    } else {
        $carouselPrevArrow.removeClass('is-disabled');
    }

    if (currentSlide >= slideCount - slidesToShow) {
        $carouselNextArrow.addClass('is-disabled');
    } else {
        $carouselNextArrow.removeClass('is-disabled');
    }
}

function attachMainCarouselEvents() {
    $carouselSlider.off('afterChange.maincarousel').off('click.maincarousel');
    $mainImageButton.off('click.mainimage');
    $mainVideoButton.off('click.mainvideo');

    $carouselSlider.on('afterChange.maincarousel', function (event, slick, currentSlide) {
        if (window.isDesktop) {
            if (_pendingSlideIndex !== null) {
                updateMainDisplay(_pendingSlideIndex);
                _pendingSlideIndex = null;
                clearTimeout(_pendingClearTimeout);
            } else {
                updateMainDisplay(currentSlide);
            }
        }
        updateMainCarouselArrows();
    });


    $mainImageButton.on('click.mainimage', function () {
        const currentSlide = $carouselSlider.slick('slickCurrentSlide');
        $zoomImageModal.data('initial-slide', currentSlide);
    });

    $mainVideoButton.on('click.mainvideo', function () {
        const currentSlide = $carouselSlider.slick('slickCurrentSlide');
        $zoomImageModal.data('initial-slide', currentSlide);
        $zoomImageModal.modal('show');
    });

    // Open zoom modal on carousel video click
    $carouselSlider.off('click.carouselvideo').on('click.carouselvideo', '.cc-pdp__video', function (e) {
        e.stopPropagation();
        const $videoItem = $(this).closest('.cc-pdp__carousel__item');
        const slideIndex = $videoItem.closest('.slick-slide').data('slick-index');

        // Update main display to show the video
        if (window.isDesktop) {
            updateMainDisplay(slideIndex);
        }

        $zoomImageModal.data('initial-slide', slideIndex);
        $zoomImageModal.modal('show');
    });
}

/**
 * Update main display (image or video) based on current slide
 */
function updateMainDisplay(slideIndex) {
    const $currentSlide = $carouselSlider.find('.cc-pdp__carousel__item').eq(slideIndex);
    const slideType = $currentSlide.attr('data-slide-type');

    if (slideType === 'video') {
        $mainImageButton.addClass('d-none');
        $mainVideoButton.removeClass('d-none');
    } else if (slideType === 'image') {
        $mainImageButton.removeClass('d-none');
        $mainVideoButton.addClass('d-none');

        const imageUrl = $currentSlide.attr('data-main-image-url');
        if (imageUrl) {
            $mainImage.attr('src', imageUrl);
        }
    }
}

function destroyZoomCarousels() {
    if ($zoomCarousel.hasClass('slick-initialized')) {
        $zoomCarousel.slick('unslick');
    }
    if ($zoomNavCarousel.hasClass('slick-initialized')) {
        $zoomNavCarousel.slick('unslick');
    }
}

function initZoomCarousels(initialSlide = 0) {
    destroyZoomCarousels();
    const arrowLabels = getCarouselArrowLabels();

    $zoomCarousel.slick({
        arrows: true,
        prevArrow: `<button type="button" class="slick-prev slick-arrow" aria-label="${arrowLabels.previous}"></button>`,
        nextArrow: `<button type="button" class="slick-next slick-arrow" aria-label="${arrowLabels.next}"></button>`,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: initialSlide,
        infinite: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    asNavFor: $zoomNavCarousel,
                }
            }
        ]
    });

    $zoomNavCarousel.slick({
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: $zoomCarousel,
        focusOnSelect: true,
        infinite: false,
    });

    $zoomCarousel.addClass('is-visible');
    $zoomNavCarousel.addClass('is-visible');
}

function attachZoomModalEvents() {
    $zoomImageModal.off('shown.bs.modal.zoom').off('hidden.bs.modal.zoom');

    $zoomImageModal.on('shown.bs.modal.zoom', function () {
        const initialSlide = $zoomImageModal.data('initial-slide') || 0;
        initZoomCarousels(initialSlide);

        $zoomCarousel.off('afterChange.zoomcarousel').on('afterChange.zoomcarousel', function (event, slick, currentSlide) {
            $carouselSlider.slick('slickGoTo', currentSlide);
            if (window.isDesktop) {
                updateMainDisplay(currentSlide);
            }
        });

        $zoomCarousel.off('click.zoomvideo').on('click.zoomvideo', '.cc-pdp__video', function (e) {
            e.stopPropagation();
        });
    });

    $zoomImageModal.on('hidden.bs.modal.zoom', function () {
        destroyZoomCarousels();
        $zoomCarousel.removeClass('is-visible');
        $zoomNavCarousel.removeClass('is-visible');
    });
}

function destroyMachineFunctionalitySlider() {
    if ($functionalitySlider.hasClass('slick-initialized')) {
        $functionalitySlider.slick('unslick');
    }
}

function initMachineFunctionalitySlider() {
    if (!window.isDesktop && $functionalitySlider.length) {
        destroyMachineFunctionalitySlider();

        $functionalitySlider.slick({
            arrows: false,
            dots: false,
            slidesToShow: 1.2,
            slidesToScroll: 1,
            infinite: false,
        });

        buildProgressBar($functionalitySlider);

        $functionalitySlider.off('afterChange.machinery').on('afterChange.machinery', function (event, slick, currentSlide) {
            updateProgressBar(currentSlide);
        });

        updateProgressBar(0);
    } else if (window.isDesktop) {
        destroyMachineFunctionalitySlider();
    }
}

function buildProgressBar($slider) {
    const slideCount = $slider.slick('getSlick').slideCount;
    const $progressBar = $('.cc-pdp__machineFunctionality__progressBar');

    $progressBar.empty();

    for (let i = 0; i < slideCount; i++) {
        $progressBar.append('<span class="cc-pdp__machineFunctionality__progressBar__fill"></span>');
    }
}

function updateProgressBar(currentSlide) {
    $('.cc-pdp__machineFunctionality__progressBar__fill').each(function (index) {
        $(this).toggleClass('active', index === currentSlide);
    });
}

function destroyCompatibleSlider() {
    if ($compatibleSlider.hasClass('slick-initialized')) {
        $compatibleSlider.slick('unslick');
    }
}

function initCompatibleSlider() {
    if ($compatibleSlider.length) {
        destroyCompatibleSlider();

        $compatibleSlider.slick({
            arrows: true,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
}

function initAllCarousels() {
    initMainCarousel();

    if ($functionalitySlider.length) {
        initMachineFunctionalitySlider();
    }

    if ($compatibleSlider.length) {
        initCompatibleSlider();
    }
}

function destroyAllCarousels() {
    destroyMainCarousel();
    destroyZoomCarousels();
    destroyMachineFunctionalitySlider();
    destroyCompatibleSlider();
}


var _skpPdpCounter = 0;
var _skpModalCounter = 1000;
var _skpObserver = null;
var _skpModalObserver = null;
var _skpProcessingTimeout = null;

function injectSkeepersNormalizationStyle() {
    if (document.getElementById('skp-normalization-style')) return;

    var styleEl = document.createElement('style');
    styleEl.id = 'skp-normalization-style';
    styleEl.textContent = '.js-prod-rating > .review__header { visibility: hidden; }';
    document.head.appendChild(styleEl);
}

/**
 * ENHANCED: Override Skeepers star colors with the site's primary color CSS variable.
 * Also fixes clipPath ID collisions by assigning unique IDs to each SVG widget.
 * Uses separate counters for PDP and modal to prevent ID collisions across lifecycle events.
 * 
 * @param {boolean} isModal - If true, uses modal counter; if false, uses PDP counter
 */
function overrideSkeepersStarColors(isModal = false) {
    var primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--color-primary').trim();

    if (!primaryColor) return;

    function ensureSkeepersWrappers(container) {
        if (!container || !container.querySelectorAll) return;

        container.querySelectorAll('.js-prod-rating').forEach(function (ratingRoot) {
            var alreadyWrapped = !!ratingRoot.querySelector(':scope > .skeepers_product__stars > .skeepers_product__stars > .review__header');
            if (alreadyWrapped) {
                ratingRoot.classList.add('skp-normalized');
                return;
            }

            var reviewHeader = ratingRoot.querySelector(':scope > .review__header');
            if (!reviewHeader) {
                return;
            }

            var outerWrapper = document.createElement('div');
            outerWrapper.className = 'skeepers_product__stars';

            var productId = ratingRoot.getAttribute('data-product-id');
            if (!productId) {
                var pidSource = ratingRoot.closest('[data-product-id], [data-pid]');
                if (pidSource) {
                    productId = pidSource.getAttribute('data-product-id') || pidSource.getAttribute('data-pid');
                }
            }

            if (productId) {
                outerWrapper.setAttribute('data-product-id', productId);
            }

            var innerWrapper = document.createElement('div');
            innerWrapper.className = 'skeepers_product__stars';
            innerWrapper.setAttribute('skp-version', 'NULL');

            reviewHeader.parentNode.insertBefore(outerWrapper, reviewHeader);
            outerWrapper.appendChild(innerWrapper);
            innerWrapper.appendChild(reviewHeader);

            ratingRoot.classList.add('skp-normalized');
        });
    }

    function processSkeepersStars(container) {
        if (!container || !container.querySelectorAll) return;

        ensureSkeepersWrappers(container);

        var ratingSelector = '.cc-pdp__product__ratings, .skeepers_product__stars, .skeepers_product__reviews, .js-prod-rating, .review__header, .stars';
        var ratingContainers = Array.from(container.querySelectorAll(ratingSelector));

        if (container.matches && container.matches(ratingSelector)) {
            ratingContainers.unshift(container);
        }

        if (!ratingContainers.length && container.querySelectorAll('.stars__item svg').length) {
            ratingContainers = [container];
        }

        ratingContainers = ratingContainers.filter(function (item, index, arr) {
            return arr.indexOf(item) === index;
        });

        ratingContainers.forEach(function (ratingContainer) {
            ratingContainer.querySelectorAll('.stars__item svg').forEach(function (svg) {
                var clipPathEl = svg.querySelector('defs clipPath');
                if (clipPathEl) {
                    var newId = isModal
                        ? 'skp-clip-' + (++_skpModalCounter)
                        : 'skp-clip-' + (++_skpPdpCounter);

                    clipPathEl.setAttribute('id', newId);

                    svg.querySelectorAll('path[clip-path]').forEach(function (path) {
                        path.setAttribute('clip-path', 'url(#' + newId + ')');
                    });
                }

                svg.querySelectorAll('path').forEach(function (path) {
                    if (path.getAttribute('fill') !== 'none') {
                        path.setAttribute('fill', primaryColor);
                    }
                    if (path.getAttribute('stroke') && path.getAttribute('stroke') !== 'none') {
                        path.setAttribute('stroke', primaryColor);
                    }
                });
            });
        });
    }

    processSkeepersStars(document);

    return processSkeepersStars;
}

/**
 * Initialize the Skeepers fix with MutationObserver.
 * Watches for dynamically-added Skeepers widgets and applies the fix.
 * Handles both PDP main content and modal content.
 */
function initSkeepersObserver() {
    var primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--color-primary').trim();

    if (!primaryColor) return;

    var processPdpStars = overrideSkeepersStarColors(false);

    if (_skpObserver) {
        _skpObserver.disconnect();
    }

    _skpObserver = new MutationObserver(function (mutations) {
        clearTimeout(_skpProcessingTimeout);
        _skpProcessingTimeout = setTimeout(function () {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) {
                        if (node.classList && (
                            node.classList.contains('skeepers_product__stars') ||
                            node.classList.contains('skeepers_product__reviews') ||
                            node.classList.contains('cc-pdp__product__ratings') ||
                            node.classList.contains('review__header')
                        )) {
                            processPdpStars(node);
                        } else if (node.querySelectorAll) {
                            processPdpStars(node);
                        }
                    }
                });
            });
        }, 50);
    });

    _skpObserver.observe(document.body, { childList: true, subtree: true });
}

/**
 * Initialize modal-specific Skeepers observer.
 * Watches the add-to-cart modal container for Skeepers widget injection.
 */
function initModalSkeepersObserver() {
    var primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--color-primary').trim();

    if (!primaryColor) return;

    var $addToCartModal = $('#addToCartProductModal');
    if (!$addToCartModal.length) return;

    var processModalStars = overrideSkeepersStarColors(true);

    if (_skpModalObserver) {
        _skpModalObserver.disconnect();
    }

    _skpModalObserver = new MutationObserver(function (mutations) {
        clearTimeout(_skpProcessingTimeout);
        _skpProcessingTimeout = setTimeout(function () {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('js-prod-rating')) {
                            processModalStars(node);
                        } else if (node.querySelectorAll) {
                            processModalStars(node);
                        }
                    }
                });
            });
        }, 50);
    });

    var modalContent = $addToCartModal.find('.cc-modal__body')[0];
    if (modalContent) {
        _skpModalObserver.observe(modalContent, { childList: true, subtree: true });
    }
}

/**
 * Hook into modal lifecycle events to re-apply Skeepers fixes.
 * This ensures the fix is applied when the modal opens and when it closes.
 */
function attachModalSkeepersHooks() {
    var $addToCartModal = $('#addToCartProductModal');
    if (!$addToCartModal.length) return;

    $addToCartModal.off('shown.bs.modal.skeepers').on('shown.bs.modal.skeepers', function () {
        var processModalStars = overrideSkeepersStarColors(true);
        processModalStars(this);
        initModalSkeepersObserver();
    });

    $addToCartModal.off('hidden.bs.modal.skeepers').on('hidden.bs.modal.skeepers', function () {
        var processPdpStars = overrideSkeepersStarColors(false);
        processPdpStars(document);
    });
}

/**
 * Initialize all Skeepers fixes on page load.
 * Called once during document ready.
 */
function initAllSkeepersFixtures() {
    injectSkeepersNormalizationStyle();
    overrideSkeepersStarColors(false);
    initSkeepersObserver();
    attachModalSkeepersHooks();
}

function updateSkeepersWidgetLayout() {
    const $widget = $(document).find('#skeepers_product_widget');
    if ($widget.length === 0) return;

    if (window.isDesktop) {
        if ($widget.hasClass('widget--vertical')) {
            $widget.removeClass('widget--vertical').addClass('widget--horizontal');
        }
    } else {
        if ($widget.hasClass('widget--horizontal')) {
            $widget.removeClass('widget--horizontal').addClass('widget--vertical');
        }
    }
}

let resizeTimeout;
function handleWindowResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
        destroyAllCarousels();
        initAllCarousels();
        updateSkeepersWidgetLayout();
    }, 250);
}

$(() => {
    // Remove data-toggle and data-target from carousel items on desktop to prevent modal
    if (window.isDesktop) {
        $('.cc-pdp__carousel__item').removeAttr('data-toggle').removeAttr('data-target');
    }
    initAllCarousels();
    attachZoomModalEvents();
    updateSkeepersWidgetLayout();
    initAllSkeepersFixtures();

    setTimeout(function () {
        updateSkeepersWidgetLayout();
    }, 1000);

    $(window).off('resize.carousels').on('resize.carousels', handleWindowResize);

    $(document).off('click.carouselitem').on('click.carouselitem', '.cc-pdp__carousel__item', function (e) {
        const slideIndex = $(this).closest('.slick-slide').data('slick-index');
        $zoomImageModal.data('initial-slide', slideIndex);

        if (window.isDesktop) {
            updateMainDisplay(slideIndex);

            const slick = $carouselSlider.slick('getSlick');
            const isAtEnd = slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;

            clearTimeout(_pendingClearTimeout);
            _pendingSlideIndex = slideIndex;

            if (!isAtEnd) {
                $carouselSlider.slick('slickNext');
            } else {
                _pendingClearTimeout = setTimeout(function () {
                    _pendingSlideIndex = null;
                }, 400);
            }

            e.preventDefault();
            e.stopPropagation();
        } else {
            $carouselSlider.slick('slickGoTo', slideIndex);
            $('#zoomImageModal').modal('show');
        }
    });

    $(document).off('click.promocode').on('click.promocode', '.js-copyPromoCode', function () {
        const promoCode = $(this).find('.js-promoCodeCopy').text().trim();
        navigator.clipboard.writeText(promoCode).then(function () {
            $('.js-promoCodeCopy').addClass('d-none');
            $('.js-promoCodeCopied').removeClass('d-none');

            setTimeout(function () {
                $('.js-promoCodeCopy').removeClass('d-none');
                $('.js-promoCodeCopied').addClass('d-none');
            }, 1500);
        }).catch(function () {
            $('.js-promoCodeCopy').removeClass('d-none');
            $('.js-promoCodeCopied').addClass('d-none');
        });
    });

    $(document).off('click.videothumb').on('click.videothumb', '.js-videoThumbnail', function () {
        const $clickedThumbnail = $(this);
        const newVideoUrl = $clickedThumbnail.attr('data-video-url');
        const $mainVideoContainer = $('.cc-pdp__expertOpinion__mainVideo');
        const $mainVideo = $mainVideoContainer.find('.js-mainExpertVideo');
        const currentVideoUrl = $mainVideo.attr('src');

        $mainVideo.attr('src', newVideoUrl);

        $('.js-videoThumbnail').removeClass('cc-pdp__expertOpinion__activeVideo');
        $clickedThumbnail.addClass('cc-pdp__expertOpinion__activeVideo');
        $clickedThumbnail.attr('data-video-url', currentVideoUrl);
    });

    $(document).off('click.videocontrol').on('click.videocontrol', '.js-videoControl', function () {
        this.paused ? this.play() : this.pause();
    });
});

$(document).on('product:updateCarousel', function () {
    _pendingSlideIndex = null;
    clearTimeout(_pendingClearTimeout);
    destroyAllCarousels();
    initAllCarousels();
    updateMainDisplay(0);
    overrideSkeepersStarColors(false);
});

/**
 * Initialize and manage live countdown timer
 */
function initCountdownTimer() {
    const $timerContainer = $('.cc-pdp__promotion__timer');

    if (!$timerContainer.length) {
        return;
    }

    const endDateStr = $timerContainer.attr('data-promo-end');
    const hasStaticDisplay = $timerContainer.find('.js-promoDisplayValue').length > 0;

    if (!endDateStr && hasStaticDisplay) {
        $timerContainer.closest('.cc-pdp__promotion__countdown').removeClass('d-none');
        return;
    }

    if (!endDateStr) {
        return;
    }

    const endDate = new Date(endDateStr).getTime();

    if (isNaN(endDate) && hasStaticDisplay) {
        $timerContainer.closest('.cc-pdp__promotion__countdown').removeClass('d-none');
        return;
    }

    if (isNaN(endDate) || Date.now() >= endDate) {
        $timerContainer.closest('.cc-pdp__promotion__countdown').remove();
        return;
    }

    let countdownInterval = null;

    function padTwoDigits(value) {
        return value < 10 ? '0' + value : String(value);
    }

    function updateCountdown() {
        const nowMs = Date.now();
        const remainingMs = endDate - nowMs;

        if (remainingMs <= 0) {
            clearInterval(countdownInterval);
            handleCountdownExpired();
            return;
        }

        const totalSeconds = Math.floor(remainingMs / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        $('.js-promoDays').text(String(days));
        $('.js-promoHours').text(padTwoDigits(hours));
        $('.js-promoMinutes').text(padTwoDigits(minutes));
        $('.js-promoSeconds').text(padTwoDigits(seconds));
    }

    function handleCountdownExpired() {
        sessionStorage.setItem('countdownExpiredAlert', 'true');

        $timerContainer.closest('.cc-pdp__promotion__countdown').fadeOut(300, function () {
            $(this).remove();
        });

        setTimeout(function () {
            location.reload();
        }, 300);
    }

    updateCountdown();

    if (Date.now() < endDate) {
        $timerContainer.closest('.cc-pdp__promotion__countdown').removeClass('d-none');
        countdownInterval = setInterval(updateCountdown, 1000);
    }
}

$(() => {
    if (sessionStorage.getItem('countdownExpiredAlert') === 'true') {
        sessionStorage.removeItem('countdownExpiredAlert');

        $('.cc-pdp__promotion__countdown').remove();

        if (window.isDesktop) {
            $('.js-countdownDesktop').removeClass('d-none').addClass('d-lg-flex');
        } else {
            $('.js-countdownMobile').removeClass('d-none').addClass('d-lg-none');
        }

        setTimeout(function () {
            if (window.isDesktop) {
                $('.js-countdownDesktop').removeClass('d-lg-flex').addClass('d-none');
            } else {
                $('.js-countdownMobile').addClass('d-none').removeClass('d-lg-none');
            }
        }, 3000);

        $(document).on('click', '.js-hideSuccessMessage', function () {
            $('.js-countdownDesktop').addClass('d-none').removeClass('d-lg-flex');
            $('.js-countdownMobile').addClass('d-none').removeClass('d-lg-none');
        });

        return;
    }

    initCountdownTimer();
});